import { Button, Icon } from "antd"
import { classNames } from "../../../../utils/classNames"
import React from "react"
import { MultiSelectItem, MultiSelectProps } from "../MultiSelect"

type Props<TValue> = {
    flatData: MultiSelectItem<TValue>[]
    size: NonNullable<MultiSelectProps<TValue>["size"]>
    labels: NonNullable<MultiSelectProps<TValue>["labels"]>
    selectedIds: TValue[]
    buttonClassName?: string
    renderTriggerElement?: (buttonProps: React.HTMLProps<HTMLButtonElement>) => React.ReactNode
}

export const MultiSelectTrigger = <TValue extends string>({
    flatData,
    selectedIds,
    labels,
    size,
    buttonClassName,
    renderTriggerElement,
    ...triggerProps
}: Props<TValue>) => {
    if (renderTriggerElement) {
        return <>{renderTriggerElement(triggerProps)}</>
    }

    const handleDropdownLabel = () => {
        const allSelected = !flatData.filter(f => !f.labelOnly).some(data => !selectedIds.includes(data.id))

        if (selectedIds.length === 1) {
            const selected = flatData.find(d => d.id === selectedIds[0])
            if (!selected) {
                return null
            }
            return labels.singleSelected(selected.renderCustomLabel?.(selected, "") || selected.label)
        }
        if (selectedIds.length > 1 && !allSelected) {
            return labels.countSelected(selectedIds.length, selectedIds)
        }
        if (allSelected) {
            return labels.allSelected(selectedIds.length, selectedIds)
        }
        if (!allSelected) {
            return labels.noSelected
        }
    }

    return (
        <Button {...triggerProps} className={classNames(classes.btn, classes.btnSize[size], buttonClassName)}>
            <div className={classes.btnLabel}>{handleDropdownLabel()}</div>
            <div className={classes.btnIconWrap}>
                {/* @ts-expect-error - antd v3 legacy issue. */}
                <Icon type="down" />
            </div>
        </Button>
    )
}

const classes = {
    btn: "!text-black/90 flex w-full items-center text-left",
    btnSize: {
        normal: "",
        large: "h-[40px] text-14",
    } as Record<NonNullable<MultiSelectProps["size"]>, string>,
    btnLabel: "flex-1 truncate",
    btnIconWrap: "mt-px text-[10px]",
}
